'use strict';

module.exports = function setRequestFailed (request, requestArgs, error, meta = {}) {
  return {
    type: 'DATA_CONNECTOR_SET_REQUEST_FAILED',
    payload: error,
    error: true,
    isStoreSetAction: true,
    meta: {
      reference: request.referenceFor(...requestArgs),
      ...meta,
    },
  };
};



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/setRequestFailed.js